import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(2),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: theme.spacing(2),
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: `${theme.spacing(1.75)} !important`,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: `${theme.spacing(2.5)} !important`,
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  highlightRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(3),
    alignSelf: 'stretch',
    width: '100%',
  },
  highlighField: {
    width: '100%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  textWidth: {
    width: `${theme.spacing(60.625)} !important`,
  },
  uploadImageWidth: {
    width: '100%',
  },
  fullWidth: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
  },
  disableTrash: {
    pointerEvents: 'none',
  },
}))
